module.exports = __webpack_public_path__ + "img/irregular_and_large.abe76bbb.svg";